import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {catchError, map, mergeMap} from 'rxjs/operators';
import {of} from 'rxjs';
import {hasMissingAdultCheckIns} from '../../shared/models/check-in-flow.model';
import {PaymentsService} from '../api/payments.service';
import {requiresDeposit} from '../../shared/models/payment-status.model';


export const reservationHasPendingDepositGuard: CanActivateFn = () => {
  const paymentsService = inject(PaymentsService);
  const router = inject(Router);

  return paymentsService.getPaymentStatus().pipe(
    map((paymentStatus) => {
      if (requiresDeposit(paymentStatus)) {
        return true;
      }
      return router.parseUrl('/');
    }),
    catchError(() => of(router.parseUrl('/')))
  );
};

